import { render } from "./PrintBadgeEditView.vue?vue&type=template&id=18d67a1c"
import script from "./PrintBadgeEditView.vue?vue&type=script&lang=js"
export * from "./PrintBadgeEditView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__